module.exports = __webpack_public_path__ + "media/merit_supply/meritSupplyLogo-white-d1fdd997.png";